import constants from '@/constants';

const MODAL_OPEN_CLASS = 'modal-open';

export default {
  props: {
    bodyClass: {
      type: String,
      default: '',
    },
    headerClass: {
      type: String,
      default: '',
    },
    closeButtonClass: {
      type: String,
      default: ''
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    clickOutsideEnabled: {
      type: Boolean,
      default: false,
    },
    gtm: [String, Object],
    fullScreen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasHeader() {
      return !!this.$slots.header;
    },
    hasFooter() {
      return !!this.$slots.footer;
    },
    classModifier() {
      return {
        'modal__content--full': this.fullScreen,
        'modal__content--with-footer': this.hasFooter,
        'modal__content--no-padding': this.noPadding,
      };
    },
  },
  methods: {
    close() {
      if (this.gtm && this.gtm.closing) {
        this.$gtm.trackEvent(this.gtm.closing);
      }
      this.$emit('modalClose');
    },
    onClickOutside() {
      if (this.clickOutsideEnabled) this.close();
    },
    afterEnter() {
      if (constants.POPUP_OVERFLOW_MODE) {
        setTimeout(() => window.scrollTo(0, 0), 0);
      }
    },
  },
  created() {
    document.documentElement.classList.add(MODAL_OPEN_CLASS);
    document.body.classList.add(MODAL_OPEN_CLASS);
    if (this.gtm) {
      const name = this.gtm.virtualPage || (typeof this.gtm === 'string' ? this.gtm : this.gtm.name);
      const virtualPage = this.gtm.virtualPage ? name : `${this.$route.path}/${name}`;

      if (virtualPage) {
        this.$gtm.trackEvent({
          event: 'pageviewTrackerEvent',
          virtualPage,
          virtualPageTitle: `modal/${name}`,
        });
      }
    }
  },
  beforeDestroy() {
    if (this.gtm && this.$route && this.$route.fullPath) {
      this.$gtm.trackEvent({
        event: 'pageviewTrackerEvent',
        virtualPage: this.$route.fullPath,
        virtualPageTitle: this.$route.name,
        closing: this.gtm,
      });
    }
    document.documentElement.classList.remove(MODAL_OPEN_CLASS);
    document.body.classList.remove(MODAL_OPEN_CLASS);
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/modal/modal.js